import { ColumnGroup as ColumnGroupPrime } from 'primereact/columngroup'

const ColumnGroup = ColumnGroupPrime

export default ColumnGroup
